/**
 * @flow
 * Created by neo on 03.06.17.
 */

import React, { Component } from 'react';
import { observable } from 'mobx';
import { observer } from 'mobx-react';
import { translate  } from 'react-i18next';
import Booking from '../../Store/Booking';
import PassengerInfo from './PassengerInfo';
import { Container, Row, Col, Button } from 'reactstrap';

type Props = {
  params: any,
};

@observer
export class BookingViewScreen extends React.Component<Props> {
  @observable booking: ?Booking = null;

  componentWillMount() {
    this.load(this.props.params.bookingId);
  }

  handleUpdate = async () => {};

  async load(bookingId: string) {
    this.booking = await Booking.get(bookingId);
  }

  render() {
    if (!this.booking) {
      return null;
    }

    return (
      <Container>
        <Row>
          <Col>
            <PassengerInfo booking={this.booking} />
          </Col>
        </Row>
      </Container>
    );
  }
}

export default translate ()(BookingViewScreen);



// WEBPACK FOOTER //
// ./src/App/Booking/View/index.js